import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RewardForm from '../../../components/forms/RewardForm';
import { RewardClient, RewardDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from '../../../services/axiosInstance';

const RewardCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const apiClient = new RewardClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Rewards', href: '/admin/rewards' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RewardDTO) => {
    setIsSubmitting(true);
    try {
      await apiClient.createReward(data);
      navigate('/admin/rewards');
    } catch (error) {
      console.error('Error creating Reward:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Create Rewards"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        <RewardForm
          initialValues={{} as RewardDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/rewards')}
        />
      </Card>
    </AdminLayout>
  );
};

export default RewardCreate;
